export const newFeatures = {
    collection: {
        level: 'Cấp độ',
        fix_time: 'Số lần sửa:',
        earn_exercise: 'Kiếm được mỗi bài tập:',
        on_selling: 'Đang bán',
        sell: 'Bán',
        edit: 'Chỉnh sửa',
        buy: 'Mua',
        stop: 'Dừng',
        cancel: 'Hủy',
        update: 'Cập nhật',
        search: 'Tìm kiếm',
    },
    sort_filter: {
        sort_by: 'Sắp xếp theo',
        filter: 'Bộ lọc',
        status: 'Trạng thái',
        sell_in: 'Bán trong',
        class: 'Lớp',
        sale_hight: 'Bán gần đây',
        sale_low: 'Cũ đến mới',
        level_hight: 'Cấp độ: cao đến thấp',
        level_low: 'Cấp độ: thấp đến cao',
        reward_hight: 'Phần thưởng: cao đến thấp',
        reward_low: 'Phần thưởng: thấp đến cao',
        fix_time_hight: 'Số lần sửa: cao đến thấp',
        fix_time_low: 'Số lần sửa: thấp đến cao',
        radio_1: 'Bắt đầu kiếm tiền',
        radio_2: 'Cần sửa ngay',
        radio_3: 'Đang bán',
        clear_all: 'Xóa tất cả',
    },
    modal_sell: {
        fee: 'Bạn sẽ nhận được %{fee} ( ~%{value}) giá trị nếu đặt lệnh bán thành công.',
        sell_nft: 'Bán NFT',
        edit_nft: 'Chỉnh sửa NFT',
        buy_Nft: 'Mua NFT',
        stop_sell: 'Dừng bán',
        want_sell_in: 'Tôi muốn bán với',
        want_buy: 'Bạn có muốn mua NFT này',
        want_stop: 'Bạn có muốn dừng bán?',
        code_2fa: 'Mã 2FA',
    },
    tab_leaf: {
        payment: 'Thanh toán',
        total_amount: 'Tổng số',
        quantity: 'Số lượng',
        pay: 'Thanh toán',
        balance: 'Số dư',
        limitMessage: 'Số dư hiện tại không đủ!',
        you_have: 'Bạn có:',
        leaf: ' lá',
    },
    transaction: {
        transaction_history: 'Lịch sử giao dịch',
        type: 'Loại',
        item_id: 'Mã hàng',
        tier: 'Cấp bậc',
        level: 'Cấp độ',
        price: 'Giá',
        token: 'Token',
        seller_buyer: 'Người bán/ Người mua',
        time: 'Thời gian',
        filter: 'Bộ lọc',
        send: 'Gửi',
    },
    common: {
        price: 'Giá',
        noData_market: 'Không có NFT phù hợp với tìm kiếm của bạn.',
        edit: 'Chình sửa',
        no_transaction: 'Bạn không có giao dịch nào.',
        all: 'Tất cả',
        buy: 'Mua',
        sell: 'Bán',
        sent: 'Đã gửi',
        receive: 'Nhận',
        connect: 'Kết nối',
        amount: 'Số lượng',
        leaves: 'Lá',



    },
    tab_ticket: {
        ticket: ' vé'
    },

};
